import CreateNote from './component';
import { CreateNoteProps } from './types';

export default CreateNote;
export type { CreateNoteProps };
